<script>
import { getOSS } from '@/api/getData'
const OSS = require('ali-oss')
const client = null
async function getOSSClient(that) {
  if (!that.$admin || !that.$admin.id) {
    const adminObjStr = localStorage.getItem('adminObjStr')
    if (!adminObjStr || adminObjStr === 'null') return
    that.$admin = JSON.parse(adminObjStr)
  }
  await getOSS(that.$admin.id)
    .then(
      res => {
        if (res.code !== 0) return
        const {
          region,
          accessKeyId,
          accessKeySecret,
          securityToken,
          bucket
        } = res.data
        that.$oss.client = new OSS({
          region: region,
          accessKeyId: accessKeyId,
          accessKeySecret,
          stsToken: securityToken,
          bucket,
          refreshSTSToken: 2 * 60 * 1000,
          refreshSTSTokenInterval: 2 * 60 * 1000
        })
      }
    )
    .catch(err => {
      console.log('ossClient getOSS set err: ', err)
      localStorage.setItem('accessToken', null)
      localStorage.setItem('adminObjStr', null)
      location.reload()
    })
}
export default {
  client,
  getOSSClient
}
</script>
